import {defineStore} from 'pinia';
import {createError} from '#imports';
import type {LegalAgreementLanguage, LegalAgreementType} from '@api';
import {LegalAgreementAdminApi} from '@api';
import {useLegalAgreementContent} from '~/composables/useLegalAgreementContent';
import {apiConfiguration} from '~/configuration/apiConfiguration';

export const useAdminLegalAgreementsStore = defineStore('admin-legal-agreements', () => {
    const legalAgreementAdminApi = new LegalAgreementAdminApi(apiConfiguration);
    const {legalAgreementContent, fetchContent} = useLegalAgreementContent();

    async function fetchVersionContent(agreementType: LegalAgreementType, versionId: string, language: LegalAgreementLanguage) {
        await fetchContent(`legal-agreement-${agreementType}-${language}-${versionId}`, () =>
            legalAgreementAdminApi.getLegalAgreementVersionContent({agreementType, versionId, language}),
        );
    }

    async function fetchDraftContent(agreementType: LegalAgreementType, language: LegalAgreementLanguage) {
        await fetchContent(`legal-agreement-${agreementType}-${language}-draft`, async () => {
            const agreement = await legalAgreementAdminApi.getLegalAgreement({agreementType});
            const draftContent = agreement.draftContents.find((content) => content.language === language);
            if (!draftContent) {
                throw createError({message: `No draft content for ${language}`, statusCode: 404});
            }
            return {content: draftContent.content};
        });
    }

    return {
        legalAgreementContent,

        fetchDraftContent,
        fetchVersionContent,
    };
});
